import React from 'react'
import ReactDOM from 'react-dom/client'
import './libs/styles/styles.scss'
import App from './app/App'
import reportWebVitals from './reportWebVitals'
import {PersistGate} from "redux-persist/integration/react"
import {Provider} from "react-redux"
import {AlertProvider} from "./utils/components/providers/AlertProvider";
import {ProgressProvider} from "./utils/components/providers/ProgressProvider";
import {persistedStore, store} from "./utils/store/store";

ReactDOM
    .createRoot(document.getElementById('root') as HTMLElement)
    .render(
        <React.StrictMode>
            <ProgressProvider>
                <AlertProvider>
                    <Provider store={store}>
                        <PersistGate loading={null} persistor={persistedStore}>
                            <App/>
                        </PersistGate>
                    </Provider>
                </AlertProvider>
            </ProgressProvider>
        </React.StrictMode>
    )

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()